import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'a180-card-footer',
  templateUrl: './card-footer.component.html',
  styleUrls: ['./card-footer.component.scss'],
})
export class CardFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
